module.exports = __webpack_public_path__ + "static/media/1244_elements_comprehensive.5949ee93.png";